// Angular
import { Component, OnInit, NgZone } from '@angular/core';
import {
  IonPopover, IonButton, PopoverController, IonIcon, AlertController
} from '@ionic/angular/standalone';

// Local Library
import { AuthFacade } from '@amwager/authentication/data-access';
import { SessionService } from '@amwager/data-access';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-account-pop-over',
  templateUrl: './account-pop-over.component.html',
  styleUrls: ['./account-pop-over.component.scss'],
  imports: [IonPopover, IonButton, IonIcon],
  standalone: true
})
export class AccountPopOverComponent implements OnInit {

  userName = '';

  constructor(
    private readonly sessionService: SessionService,
    private readonly authFacade: AuthFacade,
    private readonly popoverController: PopoverController,
    private readonly alertCtrl: AlertController,
    private readonly ngZone: NgZone
  ) { }

  ngOnInit() {
    this.userName = this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast();
  }

  async logout(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Are you sure you want to log out?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.ngZone.run(()=>{
              this.authFacade.logout();
            });
          }
        }
      ]
    });

    await alert.present();
    this.popoverController.dismiss();
  }

}
